import { CSSObject } from '@chakra-ui/react';

export const InfoExoticsContainer: CSSObject = {
  bg: 'white',
  color: 'black',
};
